// Provider grid as the social proof wall — breadth IS the feature.

const providers = [
  'OpenAI', 'Anthropic', 'Gemini', 'Bedrock', 'Azure OpenAI', 'Groq',
  'Together', 'Fireworks', 'Cerebras', 'DeepSeek', 'Mistral', 'xAI Grok',
  'Perplexity', 'Cohere', 'Moonshot', 'Qwen', 'Replicate', 'Fal.ai',
  'ElevenLabs', 'Deepgram', 'AssemblyAI', 'Cartesia', 'Stability', 'Black Forest',
  'Voyage', 'Jina', 'OpenRouter', 'Cloudflare AI', 'Vercel AI', 'Hugging Face',
  'Cursor', 'Claude Code', 'Cline', 'Aider', 'Continue', 'Roo Code',
];

export default function Features() {
  return (
    <section id="providers" className="py-24 border-t-2 border-border bg-card/40">
      <div className="container-ledger">
        <div className="max-w-2xl">
          <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-spray-magenta mb-4 font-bold">
            // Works with everything you already use
          </div>
          <h2 className="font-display text-4xl md:text-5xl uppercase leading-[0.95]">
            You already use these. <br />
            <span className="text-spray-yellow">We make them billable.</span>
          </h2>
          <p className="mt-5 text-muted-foreground max-w-xl">
            Anything with a configurable base URL works as a drop-in proxy. Point your tools at
            Key Receipt with a labelled token and we tag every request with the client it
            belongs to.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-0 border-2 border-border bg-border">
          {providers.map((p) => (
            <div
              key={p}
              className="bg-card hover:bg-spray-yellow hover:text-primary-foreground transition-colors py-6 text-center text-xs font-bold uppercase tracking-wider border border-border"
            >
              {p}
            </div>
          ))}
        </div>
        <p className="mt-6 text-[11px] text-muted-foreground font-mono uppercase tracking-wider">
          // and ~30 more — if it has a base URL, it works.
        </p>
      </div>
    </section>
  );
}
